export interface IUserProfile {
    FirstName: string;
    LastName: string;
    Email: string;
    CompanyName?: string;
    JobTitle?: string;
    MobileNumber?: string;
    Type?: string;
    State?: string;
    userSettings?: IUserSettings;
}

export interface IUserSettings {
    isFeedbackSms: boolean;
    isFeedbackEmail: boolean;
    isLeadsSms: boolean;
    isLeadsEmail: boolean;
}

enum RefrenceEntity {
    Users = 1,
    Leads = 2
}

enum RefrenceType {
    ProfilePicture = 1,
    Audio = 2
}

enum UserType {
    Administrator = 1,
    Customer = 2,
    Operator = 3
}

enum UserState {
    Pending = 1,
    Active = 2,
    Inactive = 3
}

export interface IUserProfilePayload {
    Reference: RefrenceEntity;
    Type: RefrenceType;
    ReferenceId: number;
}

export interface BlobDto {
    uri: string;
    name: string;
    contentType: string;
    content: string;
}

export interface ResourceResponse {
    data: BlobDto;
    succeeded: boolean;
}

export { UserType, UserState, RefrenceEntity, RefrenceType };